import { Injectable } from "@angular/core"
import { HttpClient } from '@angular/common/http'

import { AuthData } from './auth-data.model'
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { EnvService } from '../env.service';
import { NbToastrService } from '@nebular/theme';

interface LoginStatus {
  success:boolean;
  state:string;
}

@Injectable({ providedIn: 'root' })
export class AuthService {

  private token: string;
  private userId: string;
  private emailId: string;
  private isAuthenticated = false;
  private tokenTimer: any;
  private authStatusListener = new Subject<LoginStatus>();

  constructor(private http: HttpClient, private router: Router, private env: EnvService
    , private toastrService: NbToastrService) { }

  getToken() {
    return this.token;
  }

  getIsAuth() {
    return this.isAuthenticated;
  }

  getUserId() {
    return this.userId;
  }

  getEmailId() {
    return this.emailId;
  }

  getAuthStatusListener() {
    return this.authStatusListener.asObservable();
  }

  createUser(email: string, password: string) {
    const authData: AuthData = {
      email: email,
      password: password
    }
    this.http.post(this.env.apiUrl + "/api/user/signup", authData)
      .subscribe(response => {
        console.log(response);
        this.showToast(5000, `verification link sent to your registered emailId. `, `verification link sent to your registered emailId. `);
        setTimeout(() => {
          this.router.navigate(['home']);
        }, 5000);
      }, err => {
        console.log(err);
        this.authStatusListener.next({state:"login",success:false});
      })
  }

  showToast(duration, messageTitle, messageContent) {
    this.toastrService.show(
      messageContent,
      messageTitle,
      { duration });
  }

  login(email: string, password: string) {
    const authData: AuthData = {
      email: email,
      password: password
    }
    this.http.post<{ token: string, message: string, expiresIn: number, userId: string, emailId: string, admin_token: string }>(this.env.apiUrl + "/api/user/login", authData)
      .subscribe(response => {
        console.log(response);
        this.authStatusListener.next({state:"otp",success:true});
      }, error => {
        this.authStatusListener.next({state:"otp",success:false});
      })
  }

  verifyOtp(email:string,otp:string){
    this.http.post<{ token: string, message: string, expiresIn: number, userId: string, emailId: string, admin_token: string }>(this.env.apiUrl+'/api/user/login/verify-otp',{email,otp})
    .subscribe(response=>{
      this.token = response.token;
        if (response.token) {
          const expiresInDuration = response.expiresIn;
          this.setAuthTimer(expiresInDuration);
          this.isAuthenticated = true;
          this.userId = response.userId;
          this.emailId = response.emailId;
          this.authStatusListener.next({state:"login",success:true});
          this.saveAuthData(response.token, new Date((new Date()).getTime() + (expiresInDuration * 1000)), this.userId, response.emailId, response.admin_token)
          this.router.navigate(['home']);
        }
    },err=>{
      console.log(err);
      this.authStatusListener.next({state:"otp",success:false});
    })
  }

  autoAuthUser() {
    console.log("checking autoauth");
    const authInfo = this.getAuthData();

    if (!authInfo)
      return;

    const now = new Date();

    const expiresIn = authInfo.expirationDate.getTime() - now.getTime();

    if (expiresIn > 0) {
      this.token = authInfo.token;
      this.isAuthenticated = true;
      this.userId = authInfo.userId;
      this.emailId = authInfo.emailId;
      this.setAuthTimer(expiresIn / 1000);
      this.authStatusListener.next({state:"login",success:true});
      // this.router.navigate(['home']);
    } else {
      this.logout()
    }
  }

  logout() {
    this.token = null;
    this.isAuthenticated = false;
    this.authStatusListener.next({state:"login",success:false});
    clearTimeout(this.tokenTimer);
    this.clearAuthData();
    this.userId = null;
    this.emailId = null;
    this.router.navigate(['login']);
  }

  private setAuthTimer(duration: number) {
    this.tokenTimer = setTimeout(() => {
      //this.logout();
    }, duration * 1000);

  }

  private saveAuthData(token: string, expirationDate: Date, userId: string, emailId: string, admin_token: string) {

    localStorage.setItem("token", token);
    localStorage.setItem("expiration", expirationDate.toISOString());
    localStorage.setItem("userId", userId);
    localStorage.setItem("emailId", emailId);
    localStorage.setItem("admin_token", admin_token);

  }

  private clearAuthData() {
    localStorage.removeItem("token");
    localStorage.removeItem("expiration");
    localStorage.removeItem("userId");
    localStorage.removeItem("emailId");
    localStorage.removeItem("admin_token");
  }

  private getAuthData() {
    const token = localStorage.getItem("token");
    const expirationDate = localStorage.getItem("expiration");
    const userId = localStorage.getItem("userId");
    const emailId = localStorage.getItem("emailId");

    if (!token || !expirationDate)
      return;

    return {
      token: token,
      expirationDate: new Date(expirationDate),
      userId: userId,
      emailId: emailId
    }

  }

}
